module.exports = __webpack_public_path__ + "img/Atelier_7.e06a3c23.jpg";